import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import labels from "emun.order/_labels";
import orderConfig from "emun.order/order.config";
import cartItemShipDatePrompt from "emun.cart/cart-item-ship-date";

export default class AddMultiOrdersController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.title = $ctrl.updateItems ? "Update Orders..." : "Add " + $ctrl.product.id + " to Orders...";
		if ($ctrl.updateItems) {
			$ctrl.subTitle =
				"You have to click Update Products when you are done with your changes!";
		}
		$ctrl.labels = labels;
		$ctrl.orderConfig = orderConfig;
		$ctrl.items = [];
		//$ctrl.$cart.sessionOrders.filter((o) => o.retailerId === $ctrl.$cart.retailerId || (o.accountType == $ctrl.$cart.accountType && o.accountType != "")).forEach(function (ord) {
		$ctrl.$cart.config.custOrdersInSession($ctrl.$cart).forEach(function (ord) {
			var fullOrder = $ctrl.$cart.sessionOrders.filter((o) => o.id === ord.id)[0];
			if (fullOrder.canEdit) {
				var item = $ctrl.product.createCartItem(ord.id, "", 0);
				item.order = fullOrder;
				item.quantity = 0;
				$ctrl.items.push(item);
			}
		});
	}
	setMinimums() {
		let $ctrl = this;
		$ctrl.items.map((p) => (p.quantity = p.product.minimumOrderQty));
	}
	cartItemShipDate(item) {
		let $ctrl = this;
		return cartItemShipDatePrompt({
			cartItem: item,
			product: $ctrl.product,
		}).then((cartItem) => {
			item.shipOn = cartItem.shipOn.format("M/D/YY");
			item.shipOnMoment = cartItem.shipOn;
		});
	}
	//isInCart(ord) {
	//	let $ctrl = this;
	//	var item = ord.items.filter(l => l.productId === $ctrl.product.id);
	//	if (item.length > 0) return true;
	//	else return false;
	//}
	//findItem(ord) {
	//	let $ctrl = this;
	//	var item = ord.items.filter(l => l.productId === $ctrl.product.id);
	//	if (item.length > 0) return item[0];
	//	else return {};
	//}

	save() {
		const $ctrl = this;
		$ctrl.items
			.reduce(
				(accumulatorPromise, p) =>
					accumulatorPromise.then(() => {
						if (p.quantity > 0) {
							//const item = $ctrl.findItem(p.order);
							//item.qtyPurchased = item.quantity = p.quantity;
							//item.notes = p.notes;
							//item.shipOn = p.shipOnMoment || p.shipOn;
							//item.options = p.asShownValues || item.options || [];
							//if (p.priceOverride !== p.price) {
							//	item.priceOverride = p.priceOverride;
							//}
							if (p.optionGroup && !p.options.length) {
								return Promise.resolve();
							}
							return $ctrl.$cart.bus.send("AddCartItem.json", p);
						//	return $ctrl.isInCart(p.order)
						//		? $ctrl.$cart.bus.send("ChangeCartItemQuantity.json", item)
						//		: $ctrl.$cart.bus.send("AddCartItem.json", p);
						}
					}),
				Promise.resolve()
			)
			.then(() => $ctrl.$cart.load())
			.then(() => $ctrl.$close());
	}
}
